import {dhsDictGroup} from "@/resources";

export default {
  data() {
    return {
      dosageSelectList: [],
      oldDosageSelectList: []
    }
  },
  watch: {
    currentGoods: {
      handler(val, oldVal) {
        if (!val) return
        if (JSON.stringify(val) === '{}') return
        if (JSON.stringify(val) === JSON.stringify(oldVal)) return;
        this.form.productName = this.form.productName === (oldVal && oldVal.name || '') ? val.name : this.form.productName || val.name || '';
        if (val.dosageForm) {
          this.dosageTransfer(val.dosageForm)
        }
        this.form.productCode = this.form.productCode === (oldVal && oldVal.goodsTrackNo || '') ? val.goodsTrackNo : this.form.productCode || val.goodsTrackNo || '';
        this.form.productPackingSpecification = this.form.productPackingSpecification === (oldVal && oldVal.packingSpecification || '') ? val.packingSpecification : this.form.productPackingSpecification || val.packingSpecification || '';
        this.form.productSpecification = this.form.productSpecification === (oldVal && oldVal.specifications || '') ? val.specifications : this.form.productSpecification || val.specifications || '';
      }, immediate: true, deep: true
    }
  },
  methods: {
    dosageTransfer(key) {
      this.$http.get(`/dictGroup/dosageForm/items`).then(res => {
        this.oldDosageSelectList = res.data;
        this.oldDosageSelectList.map(m => {
          m.value = m.label
        })
        if (this.oldDosageSelectList.find(f => f.key === key) && this.oldDosageSelectList.find(f => f.key === key).label) {
          this.form.productDosage = this.oldDosageSelectList.find(f => f.key === key) && this.oldDosageSelectList.find(f => f.key === key).label;
        } else {
          this.$http.get(`dhs/dict/dosageForm/item/list`).then(res => {
            this.dosageSelectList = res.data;
            this.dosageSelectList.map(m => {
              m.value = m.label
            })
            if (this.dosageSelectList.find(f => f.key === key) && this.dosageSelectList.find(f => f.key === key).label) {
              this.form.productDosage = this.dosageSelectList.find(f => f.key === key) && this.dosageSelectList.find(f => f.key === key).label;
            } else {
              this.form.productDosage = key;
            }
          }).catch(err => {
            this.form.productDosage = key;
          })
        }
      }).catch((err) => {
        this.$http.get(`dhs/dict/dosageForm/item/list`).then(res => {
          this.dosageSelectList = res.data;
          this.dosageSelectList.map(m => {
            m.value = m.label
          })
          if (this.dosageSelectList.find(f => f.key === key) && this.dosageSelectList.find(f => f.key === key).label) {
            this.form.productDosage = this.dosageSelectList.find(f => f.key === key) && this.dosageSelectList.find(f => f.key === key).label;
          } else {
            this.form.productDosage = key;
          }
        }).catch(err => {
          this.form.productDosage = key;
        })
      })
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
      };
    },
    querySearch(queryString, cb) {
      let restaurants = this.dosageSelectList;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleSelect(item) {
    },
  }
}